// gsap
import { gsap } from "../layout";

const embedFrame = document.querySelectorAll('.wp-embedded-content');
embedFrame.forEach((el) => {
    el.addEventListener("load", ev => {
        const new_style_element = document.createElement("style");
        // new_style_element.textContent = "body { background-color: red; }";
        // ev.target.contentDocument.head.appendChild(new_style_element);
        console.log(el.target);
    });
})